// Browser Supabase client — anon key only (safe for the browser).
import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.warn('Missing REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY. See env/README.md');
}

// Sessions are never remembered: they live in sessionStorage, so closing the tab
// or the browser ends them and the next visit needs the password + a fresh 2FA
// code. Any session left in localStorage by an older build is cleared on load.
const sessionOnlyStorage = {
  getItem: (k) => sessionStorage.getItem(k),
  setItem: (k, v) => { sessionStorage.setItem(k, v); localStorage.removeItem(k); },
  removeItem: (k) => { sessionStorage.removeItem(k); localStorage.removeItem(k); },
};

try {
  localStorage.removeItem('cysops.remember');
  Object.keys(localStorage)
    .filter((k) => k.startsWith('sb-') || k.startsWith('supabase.auth'))
    .forEach((k) => localStorage.removeItem(k));
} catch { /* storage unavailable (private mode) — nothing to clean up */ }

// How long a tab may sit untouched before the user is signed out (minutes).
export const IDLE_TIMEOUT_MINUTES = Number(process.env.REACT_APP_IDLE_TIMEOUT_MINUTES) || 30;

export const supabase = createClient(url || 'http://localhost', anonKey || 'public-anon-key', {
  auth: {
    storage: sessionOnlyStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
